import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_ENDPOINT;

export const fetchServiceBookingGr = createAsyncThunk(
    'service-booking/gr', 
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/service-booking/gr`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data.data.data;
        } catch (error) {
            console.error('Error fetch service booking gr:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
);

export const createServiceBookingGr = createAsyncThunk(
    'service-booking/gr/store', 
    async (items, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.post(`${API_URL}/service-booking/gr/store`, items, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error store service booking gr:', error);
            return rejectWithValue(error.response?.data || 'Failed to store items');
        }
    }
);

export const updateStatusServiceBookingGr = createAsyncThunk(
    'service-booking/gr/update-status', 
    async (items, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.put(`${API_URL}/service-booking/update-status/${items.booking_id}`, items, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error update status service booking gr:', error);
            return rejectWithValue(error.response?.data || 'Failed to update status items');
        }
    }
);

const serviceBookingGr = createSlice({
    name: 'serviceBookingGr',
    initialState: {
        service_booking_gr: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchServiceBookingGr.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(fetchServiceBookingGr.fulfilled, (state, action) => {
            state.isLoading = false;
            state.service_booking_gr = action.payload;
        })
        .addCase(fetchServiceBookingGr.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(createServiceBookingGr.fulfilled, (state, action) => {
            state.service_booking_gr.push(action.payload.ress.data);
        })
        .addCase(updateStatusServiceBookingGr.fulfilled, (state, action) => {
            const index = state.service_booking_gr.findIndex((item) => item.booking_id === action.payload.data.booking_id);
            if (index !== -1) {
                state.service_booking_gr[index] = { ...state.service_booking_gr[index], ...action.payload.data };
            }
            state.isLoading = false;
        });
    },
});

export default serviceBookingGr.reducer;